import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/auth/authSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
export default store;
